import React from 'react';
import Tick from '@atlaskit/icon/core/check-circle';
import Error from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives';
import Flag, { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import { removeNotification } from '../../../../scenes/PreferencesCenter/preferencesSlice';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { IconType } from './notifications';

const NotificationFlagGroup = () => {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector((state) => state.preferences.notifications);

  const handleDismiss = () => {
    dispatch(removeNotification());
  };

  const getIcon = (iconType: IconType) => {
    switch (iconType) {
      case 'success':
        return <Tick label='Success' color={token('color.icon.success')} />;
      case 'error':
        return <Error label='Error' color={token('color.icon.danger')} />;
    }
  };

  return (
    <Box>
      <FlagGroup onDismissed={handleDismiss}>
        {notifications.map((notification) =>
          notification.isAutoDismissFlag ? (
            <AutoDismissFlag
              id={notification.id}
              icon={getIcon(notification.iconType)}
              key={notification.key}
              title={notification.title}
              description={notification.description}
            />
          ) : (
            <Flag
              id={notification.id}
              icon={getIcon(notification.iconType)}
              key={notification.key}
              title={notification.title}
              description={notification.description}
            />
          ),
        )}
      </FlagGroup>
    </Box>
  );
};

export default NotificationFlagGroup;
